// payroll-misc-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'r1l.pension.org': 'Org. {org}',
  'r1l.pension.voucherInline': 'Voucher {voucher}',
  'r1l.pension.employeesInline': '{count} employees',
  'r1l.run.salaryTo': 'Salary to {name}',
  'r1l.holiday.paidShort': 'Paid:',
  'r1l.overview.holidayPayShort': 'Hol. pay:',
  'r1l.dialogs.correctionHint': 'Use the correction icon next to the amount to adjust the payout, e.g. if there is not enough money in the account to pay out everything.',
  'r1l.shared.addAccount': '+ Add account',
  'r1l.tax.agaNote': 'Employer\'s contribution is paid collectively per period. Pension premium is included in the period in which it was actually paid.',
  'r1l.tax.partialNote': 'A partial payment is distributed proportionally between withholding tax and employer\'s contribution.',
  'r1l.tax.annulledNote': 'Cancelled payments are not kept in the trial balance.',
  'r1l.employee.saved': 'Employee saved.',
});
